import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  CHECK_SHIFT_TYPE_QUERY_KEY,
  CHECK_SHIFT_TYPE_URL
} from './queryConstants'

type ShiftTypeCheck = {
  shiftTypeId: string
}

type RotaUsageCheck = {
  patterns: unknown[]
  instances: unknown[]
  revisions: unknown[]
}

type UseCheckShiftTypeReturn = {
  checkShiftTypeUsedInRota: (values: ShiftTypeCheck) => Promise<RotaUsageCheck>
  isLoading: boolean
}

const useCheckShiftType = (): UseCheckShiftTypeReturn => {
  const createFunction = async (values: ShiftTypeCheck) => {
    return postJSON({
      url: CHECK_SHIFT_TYPE_URL,
      method: 'POST',
      json: values,
      isRota: true
    })
  }

  const { mutateAsync: checkShiftTypeUsedInRota, isLoading } = useMutation<
    RotaUsageCheck,
    unknown,
    ShiftTypeCheck,
    unknown
  >([CHECK_SHIFT_TYPE_QUERY_KEY], createFunction)

  return {
    checkShiftTypeUsedInRota,
    isLoading
  }
}

export default useCheckShiftType
